<template>
    <div class="page-layout blank contacts-manage">
        <div class="pr-3 pl-3">
            <!-- Breadcrumb Section -->
            <div class="d-flex flex-wrap justify-content-between align-items-center">
                <div class="breadcrumbnew">
                    <!-- <span>Auction</span> -->
                    <span @click="$router.push('/auction/bidderlistview/'+auction_id)">Bidder List View</span>
                </div>
            </div>
        </div>
        <div class="d-flex align-items-center justify-content-center h-100" v-if="ajaxCallInProgress">
            <half-circle-spinner :animation-duration="1000" :size="60" color="#00448b"
                style="margin: 0 auto;" />
        </div>
        <div v-else class="create-auction-container w-100 pb-4 mb-8">
        <div class="main-div">
                <div class="create-auction-header d-flex align-items-center justify-content-between text-flow">
                    <span class="fs-14  pl-3 text-white ml-3">Bidder Information</span>
                    <span class="pointer ml-2" @click="showAuctionInfoData()">
                        <i v-if="!showAuctionInfo" class="icon-chevron-double-up text-white fw-500 fs-20"></i>
                        <i v-else class="icon-chevron-double-down text-white fw-500 fs-20"></i>
                    </span>
                </div>
                <!-- Bidder Information Section -->
                <div v-if="showAuctionInfo" class="pl-10 pr-10">
                    <div class="row">
                        <div class="col-lg-4 col-md-6 col-sm-12 pt-6">
                            <div class="w-100">
                                <span class="input-label">Bidder Name</span>
                                <div class="d-flex align-content-center mt-2">
                                    <input type="text" autocomplete="off" name="bidder_name" class="input-field input-width" maxlength="100" v-model="bidder_name" placeholder="Bidder Name" disabled/>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-6 col-sm-12 pt-6">
                            <div class="w-100">
                                <span class="input-label">Company Name</span>
                                <div class="d-flex align-content-center mt-2">
                                    <input type="text" autocomplete="off" disabled name="company_name" class="input-field input-width" v-model="company_name" placeholder="Company Name"/>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-6 col-sm-12 pt-6">
                            <div class="w-100">
                            <span class="input-label">Phone Number</span>
                            <vue-tel-input v-bind="bindProps" disabled
                                class="number-field-width-customer teleContactborderedDark new-align-tel ml-0 mt-2"
                                name="mobile_number" v-model="contact_mobile_number.phone_number"
                                v-validate="{required:true,min:10}" :valid-characters-only="true"
                                :maxLen="15" placeholder="Enter Mobile Number"
                                :disabledFormatting="false" style="width:100% !important; margin-right: 30px;">
                            </vue-tel-input>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-6 col-sm-12 pt-6">
                            <div class="w-100">
                                <span class="input-label">Email ID</span>
                                <div class="d-flex align-content-center mt-2">
                                    <input type="text" autocomplete="off" disabled name="email" class="input-field input-width" v-model="email" placeholder="Company Name"/>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-6 col-sm-12 pt-6">
                            <div class="w-100">
                                <span class="input-label">Appeal Date</span>
                                <date-picker v-model="appeal_date" name="appeal_date"
                                    disabled
                                    class="meetinfdatetime mx-left calendar-edit-per mr-1 mt-2"
                                    format="MM/DD/YYYY" value-type="format" type="date" lang="en"
                                    placeholder="Select Date"
                                    :clearable="false" :editable="false" confirm confirm-text="APPLY">
                                </date-picker>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-6 col-sm-12 pt-6">
                            <div class="w-100">
                                <span class="input-label">Auction applied for</span>
                                <div class="d-flex align-content-center mt-2">
                                    <input type="text" autocomplete="off" disabled name="auction_applied_for" class="input-field input-width" v-model="auction_applied_for" placeholder="Company Name"/>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-6 col-sm-12 pt-6">
                            <div class="row">
                                <div class="col-lg-8 col-md-8 col-sm-8">
                                    <span class="input-label">
                                        Auction Opening Date
                                    </span>
                                    <div class="d-flex align-items-center mt-2">
                                        <date-picker v-model="auction_opening_date" v-validate="'required'" name="auction_opening_date"
                                            class="meetinfdatetime mx-left calendar-edit-per mr-1"
                                            format="MM/DD/YYYY" value-type="format" type="date" lang="en"
                                            placeholder="Select Date"
                                            disabled
                                            :clearable="false" :editable="false" confirm confirm-text="APPLY">
                                        </date-picker>
                                    </div>
                                </div>
                                <div class="col-lg-4 col-md-4 col-sm-4">
                                    <span class="input-label">
                                        Time
                                    </span>
                                    <el-select
                                        name="auction_opening_time" class="mt-2 schedule_time w-100" v-model="auction_opening_time"
                                        style="border-radius: 6px;border: 1px solid #3f3f3f !important;"
                                        placeholder="Select Time" 
                                        disabled
                                        :popper-append-to-body="false">
                                        <el-option v-for="(item, index) in opening_time_format" :key="index"
                                            :label="item" :value="item">
                                        </el-option>
                                    </el-select>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-6 col-sm-12 pt-6">
                            <div class="row">
                                <div class="col-lg-8 col-md-8 col-sm-8">
                                    <span class="input-label">
                                        Auction Closing Date<span class="fs-14 text-danger">*</span>
                                    </span>
                                    <div class="d-flex align-items-center mt-2">
                                        <date-picker v-model="auction_closing_date" name="auction_closing_date"
                                            disabled
                                            class="meetinfdatetime mx-left calendar-edit-per mr-1"
                                            format="MM/DD/YYYY" value-type="format" type="date" lang="en"
                                            placeholder="Select Date"
                                            :clearable="false" :editable="false" confirm confirm-text="APPLY">
                                        </date-picker>
                                    </div>
                                </div>
                                <div class="col-lg-4 col-md-4 col-sm-4">
                                    <span class="input-label">
                                        Time
                                    </span>
                                    <el-select
                                        name="auction_closing_time" class="mt-2 schedule_time w-100" v-model="auction_closing_time"
                                        style="border-radius: 6px;border: 1px solid #3f3f3f !important;"
                                        placeholder="Select Time"
                                        disabled
                                        :popper-append-to-body="false">
                                        <el-option v-for="(item, index) in closing_time_format" :key="index"
                                            :label="item" :value="item">
                                        </el-option>
                                    </el-select>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-12 col-md-12 col-sm-12 mt-6">
                            <span class="input-label">
                                Notes
                            </span>
                            <div class="d-flex align-items-center">
                                <textarea-autosize class="digi-textarea white-background bordered" disabled name="notes" placeholder="Add Notes" maxlength="1000" v-model="notes" style="height: 44px !important;overflow: overlay !important;"/>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="create-auction-header d-flex align-items-center justify-content-between text-flow mt-6">
                    <span class="fs-14  pl-3 text-white ml-3">Items Details</span>
                    <span class="pointer ml-2" @click="showAuctionItemsDetals()">
                        <i v-if="!showAuctionItems" class="icon-chevron-double-up text-white fw-500 fs-20"></i>
                        <i v-else class="icon-chevron-double-down text-white fw-500 fs-20"></i>
                    </span>
                </div>
                <!-- Table Section -->
                <div v-if="showAuctionItems">
                    <div class="pl-10 pr-10 pt-6" v-for="(table, table_index) in auction_table" :key="table_index">
                        <div class="table-div mt-4 p-4">
                            <div v-if="table.table_data.length == 0">
                                <div class="table-name-section mt-8 text-white fs-14 fw-600 pt-2 pl-4">
                                    Action Table
                                </div>
                                <div class="text-blace fs-14 mt-6 fw-500 d-flex justify-content-center align-items-center" style="border: 1px solid black; border-radius: 5px; height: 150px;">No Tables added yet!</div>
                            </div>
                            <div v-else>
                                <div class="table-name-section mt-8">
                                    <input type="text" autocomplete="off" name="columns" disabled class="table-input-field" v-model="table.table_name" placeholder="Enter Name" />
                                </div>
                                <div style="overflow: auto;">
                                    <table class="auction-data-table mt-10" style="width: 100% !important;text-align: left;">
                                        <thead style="width: 100% !important">
                                            <tr>
                                                <th v-for="(headingName, head_index) in table.header_data" :key="head_index"
                                                    style="height: 38px;">
                                                    <input type="text" class="fw-600 fs-14" disabled v-model="table.header_data[head_index]" />
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(row, row_index) in table.table_data"
                                                :key="row_index">
                                                <template v-for="(col,col_index) in row">
                                                    <td :key="col_index" v-if="col_index != 'row_id'"
                                                        style="height: 38px;">
                                                        <input type="text" class="table-list" disabled v-model="row[col_index]"/>
                                                    </td>
                                                </template>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import auction from "../mixins/auction.js"
import { HalfCircleSpinner } from "epic-spinners";
export default {
    mixins: [auction],components: {
            HalfCircleSpinner,
        },
    data() {
        return{
            bindProps: {
                mode: "international",
                defaultCountry: "US"
            },
            showAuctionInfo: true,
            showAuctionItems: true,
            bidder_name: "",
            company_name: "",
            contact_mobile_number: {
                phone_number: "",
                dial_code: "1",
                country_code: "US",
                phone_type: ""
            },
            email: "",
            appeal_date: "",
            auction_applied_for: "",
            auction_opening_date: "",
            auction_opening_time: "",
            auction_closing_date: "",
            auction_closing_time: "",
            opening_time_format: [
                '00:00',
                '00:15',
                '00:30',
                '00:45',
                '01:00',
                '01:15',
                '01:30',
                '01:45',
                '02:00',
                '02:15',
                '02:30',
                '02:45',
                '03:00',
                '03:15',
                '03:30',
                '03:45',
                '04:00',
                '04:15',
                '04:30',
                '04:45',
                '05:00',
                '05:15',
                '05:30',
                '05:45',
                '06:00',
                '06:15',
                '06:30',
                '06:45',
                '07:00',
                '07:15',
                '07:30',
                '07:45',
                '08:00',
                '08:15',
                '08:30',
                '08:45',
                '09:00',
                '09:15',
                '09:30',
                '09:45',
                '10:00',
                '10:15',
                '10:30',
                '10:45',
                '11:00',
                '11:15',
                '11:30',
                '11:45',
                '12:00',
                '12:15',
                '12:30',
                '12:45',
                '13:00',
                '13:15',
                '13:30',
                '13:45',
                '14:00',
                '14:15',
                '14:30',
                '14:45',
                '15:00',
                '15:15',
                '15:30',
                '15:45',
                '16:00',
                '16:15',
                '16:30',
                '16:45',
                '17:00',
                '17:15',
                '17:30',
                '17:45',
                '18:00',
                '18:15',
                '18:30',
                '18:45',
                '19:00',
                '19:15',
                '19:30',
                '19:45',
                '20:00',
                '20:15',
                '20:30',
                '20:45',
                '21:00',
                '21:15',
                '21:30',
                '21:45',
                '22:00',
                '22:15',
                '22:30',
                '22:45',
                '23:00',
                '23:15',
                '23:30',
                '23:45',
            ],
            closing_time_format: [
                '00:00',
                '00:15',
                '00:30',
                '00:45',
                '01:00',
                '01:15',
                '01:30',
                '01:45',
                '02:00',
                '02:15',
                '02:30',
                '02:45',
                '03:00',
                '03:15',
                '03:30',
                '03:45',
                '04:00',
                '04:15',
                '04:30',
                '04:45',
                '05:00',
                '05:15',
                '05:30',
                '05:45',
                '06:00',
                '06:15',
                '06:30',
                '06:45',
                '07:00',
                '07:15',
                '07:30',
                '07:45',
                '08:00',
                '08:15',
                '08:30',
                '08:45',
                '09:00',
                '09:15',
                '09:30',
                '09:45',
                '10:00',
                '10:15',
                '10:30',
                '10:45',
                '11:00',
                '11:15',
                '11:30',
                '11:45',
                '12:00',
                '12:15',
                '12:30',
                '12:45',
                '13:00',
                '13:15',
                '13:30',
                '13:45',
                '14:00',
                '14:15',
                '14:30',
                '14:45',
                '15:00',
                '15:15',
                '15:30',
                '15:45',
                '16:00',
                '16:15',
                '16:30',
                '16:45',
                '17:00',
                '17:15',
                '17:30',
                '17:45',
                '18:00',
                '18:15',
                '18:30',
                '18:45',
                '19:00',
                '19:15',
                '19:30',
                '19:45',
                '20:00',
                '20:15',
                '20:30',
                '20:45',
                '21:00',
                '21:15',
                '21:30',
                '21:45',
                '22:00',
                '22:15',
                '22:30',
                '22:45',
                '23:00',
                '23:15',
                '23:30',
                '23:45',
            ],
            notes: "",
            bidder_id: "",
            bidder_data: [],
            auction_table: [],
            ajaxCallInProgress: false
        }     
    },
    methods: {
        showAuctionItemsDetals(){
            if (this.showAuctionItems == true){
                this.showAuctionItems = false;
            } else {
                this.showAuctionItems = true
            } 
        },
        showAuctionInfoData(){
            if (this.showAuctionInfo == true){
                this.showAuctionInfo = false;
            } else {
                this.showAuctionInfo = true
            } 
        },
        //API call to get bidder data based on id
        async loadBidderDetails(){
            this.ajaxCallInProgress = true
            try {
                let params = {
                    bidder_id: this.bidder_id
                }
                let response = await this.getBidderInfoAPI(params)
                this.bidder_data = response.response.auction_data
                // console.log(this.bidder_data)
                this.bidder_name = this.bidder_data.bidder_name
                this.company_name = this.bidder_data.company_name ? this.bidder_data.company_name : "-"
                this.contact_mobile_number.phone_number = this.bidder_data.phone_number.phone_number
                this.contact_mobile_number.dial_code = this.bidder_data.phone_number.dial_code
                this.contact_mobile_number.country_code = this.bidder_data.phone_number.country_code
                this.contact_mobile_number.phone_type = this.bidder_data.phone_number.phone_type
                this.email = this.bidder_data.bidder_email
                this.appeal_date = this.bidder_data.appeal_date
                this.auction_applied_for = this.bidder_data.auction_table_data.table_details[0].table_name ? this.bidder_data.auction_table_data.table_details[0].table_name : "-"
                this.auction_opening_date = this.bidder_data.auction_start_date
                this.auction_opening_time = this.bidder_data.auction_start_time
                this.auction_closing_date = this.bidder_data.auction_end_date
                this.auction_closing_time = this.bidder_data.auction_end_time
                this.notes = this.bidder_data.notes ? this.bidder_data.notes : "-"
                this.auction_table = this.bidder_data.auction_table_data.table_details
                this.auction_id = this.bidder_data.auction_id
            } catch (error) {
                this.ajaxCallInProgress = false
            }
            this.ajaxCallInProgress = false
        },
    },
    mounted(){
        this.bidder_id = this.$route.params.id;
        this.loadBidderDetails();
    },
}
</script>
<style scoped>
    .create-auction-container {
        background-color: #fff;
        padding: 15.5px 0 0px 0;
        border-radius: 6px;
    }
    .create-auction-header {
        padding: 9.9px 15px;
        background-color: #00448b;
    }
    .main-div {
        background: #fff;
        border-top-right-radius: 10px;
        border-top-left-radius: 10px;
        border-bottom-right-radius: 10px;
        border-bottom-left-radius: 10px;
        padding-top: 10px;
        padding-bottom: 10px;
    }
    .input-label {
        font-weight: 600;
        line-height: 1.5;
        letter-spacing: 0.39px;
        text-align: left;
        color: #00448b;
        padding: 0 0 6px 0px;
        font-size: 14px;
    }
    .input-field {
        border-radius: 6px !important;
        border: solid 0.5px #3f3f3f;
        background-color: #fff;
        padding: 8px 10px;
        width: 100% !important;
        height: 40px;
        color: black;
        font-size: 14px !important;
        font-weight: 600;
    }
    .table-input-field {
        border-bottom: 0px solid #fff !important;
        padding: 10px 16px 4px 10px !important;
        margin-left: 15px !important;
        width: 20% !important;
        color: #fff !important;
        font-size: 14px !important;
        font-weight: 600 !important;
        background-color: #00448b !important;
    }
    .input-width {
        border-radius: 5px !important;
        border: solid 0.5px #3f3f3f;
        background-color: #fff;
        padding: 8px 10px;
        width: 100% !important;
        height: 40px !important;
    }
    .table-div{
        border: 1px solid black;
        border-radius: 5px;
        height: auto;
    }
    .table-name-section{
        height: 40px !important;
        background-color: #00448b !important;
    }
    @media only screen and (min-width: 0px) and (max-width: 767px) {
        .row-padding-right{
            padding-right: 36px !important;
        }
    }
    .auction-data-table>tbody>tr:first-child td, .auction-data-table>tbody>tr:first-child td input {
        background: #00448B !important;
        color: #ffffff !important;
        border-bottom: 0.5px solid rgba(0, 0, 0, 0.35);
    }
    .auction-data-table tbody tr td input {
        font-weight: 600;
        text-align: left !important;
        border-bottom: 0px solid #000 !important;
    }
    .table-list:disabled{
        background-color: #fff !important
    }
    input:disabled{
        cursor: no-drop;
    }
    .auction-data-table>tbody>tr:first-child td, .auction-data-table>tbody>tr:first-child td input {
        background: #fff !important;
        color: #303031 !important;
        border-bottom: 0.5px solid rgba(0, 0, 0, 0.35);
    }
    .auction-data-table tbody tr td input {
        font-weight: 600;
        text-align: left !important;
        padding: 0px 30px !important;
        border-bottom: 0px solid #000 !important;
    }
    .auction-data-table thead tr th {
        background: #00448b;
        color: #fff;
        padding: 10px 30px;
        font-size: 14px;
        font-weight: 600;
        white-space: nowrap;
        border: 1px solid #000 !important;
    }
    .auction-data-table thead tr th:first-child {
        border-top-left-radius: 5px;
    }
    .auction-data-table thead tr th:last-child {
        border-top-right-radius: 5px;
    }
    .auction-data-table>thead>tr>th input {
        background: #00448B !important;
        color: #ffffff !important;
        border-bottom: 0px solid #fff !important;
    }
    .auction-data-table>tbody>tr:first-child td input::placeholder{
        color: #7b7f83 !important;
    }
    .auction-data-table>tbody>tr:first-child td {
		border-bottom: 0.5px solid rgba(0, 0, 0, 0.35) !important;
	}
    .teleContactborderedDark.vue-tel-input.number-field-width-customer input:disabled {
        color: #303031 !important;
    }
    .digi-textarea.bordered {
        color: #303031 !important;
    }
</style>


// WEBPACK FOOTER //
// src/components/Auction/BidderInfoView.vue